/* eslint-disable @typescript-eslint/default-param-last */
import { Reducer } from 'redux';
import { IPOSCategories } from '../../../types';
import { POSCategories } from './types';

const initialState: IPOSCategories | null = null;

export const posCategoriesReducer: Reducer<IPOSCategories | null> = (state = initialState, action) => {
  switch (action.type) {
    case POSCategories.GET_POS_CATEGORIES_SUCCESS: {
      return action.payload;
    }
    default: {
      return state;
    }
  }
};
